document.addEventListener('alpine:init', () => {
  Alpine.data('Theme_ModalCart', ({ openOnAddToCart }) => {
    return {
      scrollPosition: 0,
      resizeHandler: null,
      touchmoveHandler: null,
      textareaElement: null,
      onFocusInHandler: null,
      onFocusOutHandler: null,
      init() {
        // console.log('Theme_ModalCart 컴포넌트 초기화됨');

        if (openOnAddToCart === true) {
          document.body.addEventListener('baseline:cart:afteradditem', () => {
            Alpine.store('modals').closeAll();

            Alpine.store('modals').open('cart');
          });
        }

        // 'cart' 모달을 'rightDrawer'로 등록
        Alpine.store('modals').register('cart', 'rightDrawer');

        // 모달의 열림/닫힘 상태를 감지하여 스크롤 고정 및 해제 처리
        this.$watch('$store.modals.rightDrawer.contents', (newValue, oldValue) => {
          if (newValue === 'cart') {
            // 모달이 열렸을 때
            this.onModalOpen();
          } else if (oldValue === 'cart') {
            // 모달이 닫혔을 때
            this.onModalClose();
          }
        });
      },
      fixBodyScroll() {
        // 현재 스크롤 위치 저장
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        // console.log('현재 스크롤 위치:', this.scrollPosition);

        // body 스타일을 변경하여 스크롤 고정
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = '100%'; // 가로 스크롤바 방지
      },
      releaseBodyScroll() {
        // body 스타일 원래대로 복원
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';

        // 스크롤 위치 복원 (즉시 이동)
        window.scrollTo({ top: this.scrollPosition, behavior: 'auto' });
      },
      onModalOpen() {
        // console.log('onModalOpen 호출됨');

        // 다음 이벤트 루프로 호출을 지연
        setTimeout(() => {
          // 모달이 열릴 때 스크롤 고정
          this.fixBodyScroll();

          // textarea 요소를 찾아서 이벤트 리스너 등록
          this.textareaElement = document.querySelector('.right-drawer-cart .drawer-cart-container .cart-footer .cart-footer-container textarea');

          if (this.textareaElement) {
            // 이벤트 핸들러 참조 저장
            this.onFocusInHandler = this.onFocusIn.bind(this);
            this.onFocusOutHandler = this.onFocusOut.bind(this);

            // 포커스 이벤트 리스너 등록
            this.textareaElement.addEventListener('focus', this.onFocusInHandler);
            this.textareaElement.addEventListener('blur', this.onFocusOutHandler);

            // 외부 클릭 감지를 위한 이벤트 리스너 등록
            document.addEventListener('click', this.onDocumentClick.bind(this));
          } 
          // else {
          //   console.warn('textarea 요소를 찾을 수 없습니다.');
          // }
        }, 0);
      },
      onModalClose() {
        // textarea 이벤트 리스너 제거
        if (this.textareaElement) {
          this.textareaElement.removeEventListener('focus', this.onFocusInHandler);
          this.textareaElement.removeEventListener('blur', this.onFocusOutHandler);
          this.textareaElement = null;
          this.onFocusInHandler = null;
          this.onFocusOutHandler = null;

          // 외부 클릭 이벤트 리스너 제거
          document.removeEventListener('click', this.onDocumentClick.bind(this));
        }

        // 스크롤 고정 해제
        this.releaseBodyScroll();
      },
      preventDefault(event) {
        event.preventDefault();
      },
      onFocusIn(event) {
        // 모바일에서만 적용
        if (/Mobi|Android/i.test(navigator.userAgent)) {
          // console.log('textarea에 포커스가 생김');

          // touchmove 이벤트 리스너 추가
          this.touchmoveHandler = this.preventDefault.bind(this);
          document.body.addEventListener('touchmove', this.touchmoveHandler, { passive: false });
        }
      },
      onFocusOut(event) {
        // 모바일에서만 적용
        if (/Mobi|Android/i.test(navigator.userAgent)) {
          // console.log('textarea의 포커스가 사라짐');

          // touchmove 이벤트 리스너 제거
          if (this.touchmoveHandler) {
            document.body.removeEventListener('touchmove', this.touchmoveHandler, { passive: false });
            this.touchmoveHandler = null;
          }
        }
      },
      onDocumentClick(event) {
        // textarea 외부를 클릭했을 때 onFocusOut 실행
        if (this.textareaElement && !this.textareaElement.contains(event.target)) {
          this.onFocusOut();
        }
      },
    };
  });
});
